<template>
  <div>
    <collapse title="Descripción completa de los servicios solicitados">
      <validation-provider
        v-if="!isReadOnly"
        v-slot="{ errors }"
        :custom-messages="{
          required: 'El campo es requerido.',
        }"
        rules="required"
      >
        <custom-text-area
          v-model="model.fullDescription"
          :count-classes="['d-block', 'small-counter']"
          :custom-error-msg="errors[0]"
          :error="errors[0]"
          label="A. Explique en detalle los servicios solicitados, lo que espera para cada tarea y en caso de tener una fecha o periodo limite favor indicar cuando debe estar completada la misma. La lista debe incluir especificaciones técnicas y de ejecución."
          :maxlength="5000"
          show-char-count
        />
      </validation-provider>
      <div v-else-if="isReadOnly" class="my-2">
        <div class="my-2">
          A. Explique en detalle los servicios solicitados, lo que espera para
          cada tarea y en caso de tener una fecha o periodo limite favor indicar
          cuando debe estar completada la misma. La lista debe incluir
          especificaciones técnicas y de ejecución.
        </div>
        <label class="data-label">
          {{ model.fullDescription | empty }}
        </label>
      </div>
      <div class="custom-font my-2">
        B. Requisitos de personal. Se espera que los empleados del contratista
        tengan un mínimo de cualificaciones o destrezas. Especifique si el DEPR
        exige alguna licencia, cualificaciones o conocimientos específicos.
      </div>
      <validation-provider
        v-if="!isReadOnly"
        v-slot="{ errors }"
        :custom-messages="{
          required: 'El campo es requerido.',
        }"
        rules="required"
      >
        <custom-text-area
          v-model="model.qualifications"
          :count-classes="['d-block', 'small-counter']"
          :custom-error-msg="errors[0]"
          :error="errors[0]"
          label="Cualificaciones o Destrezas:"
          :maxlength="3000"
          show-char-count
        />
      </validation-provider>
      <div v-else-if="isReadOnly" class="my-2">
        <div>
          Cualificaciones o Destrezas:
        </div>
        <label class="data-label">
          {{ model.qualifications | empty }}
        </label>
      </div>
      <validation-provider
        v-if="!isReadOnly"
        v-slot="{ errors }"
        :custom-messages="{
          required: 'El campo es requerido.',
        }"
        rules="required"
      >
        <custom-text-area
          v-model="model.licenses"
          :count-classes="['d-block', 'small-counter']"
          :custom-error-msg="errors[0]"
          :error="errors[0]"
          label="Licencias:"
          :maxlength="3000"
          show-char-count
        />
      </validation-provider>
      <div v-else-if="isReadOnly">
        <div>
          Licencias:
        </div>
        <label class="data-label">
          {{ model.licenses | empty }}
        </label>
      </div>
      <validation-provider
        v-if="!isReadOnly"
        v-slot="{ errors }"
        :custom-messages="{
          required: 'El campo es requerido.',
        }"
        rules="required"
      >
        <custom-text-area
          v-model="model.specificKnowledge"
          :count-classes="['d-block', 'small-counter']"
          :custom-error-msg="errors[0]"
          :error="errors[0]"
          label="Conocimientos Específicos:"
          :maxlength="3000"
          show-char-count
        />
      </validation-provider>
      <div v-else-if="isReadOnly">
        <div class="my-2">
          Conocimientos Específicos:
        </div>
        <label class="data-label">
          {{ model.specificKnowledge | empty }}
        </label>
      </div>
      <div class="custom-font my-2">
        C. Equipo suministrado por el DEPR y otros recursos que deberá
        suministrar el contratista. Describa los equipos y recursos que el DEPR
        proveerá al contratista para que este brinde sus servicios.
      </div>

      <validation-provider v-slot="{ validated }" rules="required">
        <equipments
          ref="equipments"
          v-model="model.equipments"
          :is-read-only="isReadOnly"
        />
        <error
          v-if="validated && !model.equipments.length"
          message="Debe haber al menos 1 equipo agregado."
          variant="no-border"
        />
      </validation-provider>

      <div class="custom-font my-2">
        D. Reportes requeridos. Describa los reportes que deberá someter el
        contratista para demostrar su progreso
      </div>

      <validation-provider v-slot="{ validated }" rules="required">
        <reports
          ref="reports"
          v-model="model.reports"
          :is-read-only="isReadOnly"
        />
        <error
          v-if="validated && !model.reports.length"
          message="Debe haber al menos 1 reporte agregado."
          variant="no-border"
        />
      </validation-provider>
    </collapse>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import Collapse from '@/components/common/SimpleCollapse.vue';
import CustomTextArea from 'CustomTextArea';
import Error from 'custom-error';
import Reports from './Reports.vue';
import Equipments from './Equipments.vue';

export default {
  name: 'ExplanatoryFields',
  components: {
    Collapse,
    ValidationProvider,
    CustomTextArea,
    Error,
    Reports,
    Equipments,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {};
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateChildrenOnSubmit() {
      const eqOk = (await this.$refs.equipments?.validateAndMark?.()) ?? true;
      const rpOk = (await this.$refs.reports?.validateAndMark?.()) ?? true;
      return eqOk && rpOk;
    },
  },
};
</script>
<style scoped></style>
